import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useFilterOptions(id: string) {
    const { productService } = useService();
    const { enqueueSnackbar } = useSnackbar();
    const { data, isLoading } = useQuery<string[], Error>(['filters', id], () => productService.getOptions(id), {
        onError: error => {
            enqueueSnackbar(error.message, { variant: 'error' });
        },
    });

    return { options: data, isLoading } as const;
}
